import HomeHeroBanner from "./homeHeroBanner";
import HomeSectionOne from "./homeSection1-final";
import HomeSectionTwo from "./homeSection2";
import HomeSectionThree from "./homeSection3";
import Footer from "../navigation-footer/footer";
import HomeSectionFour from "./homeSection4";
import HomeSectionFive from "./homeSection5";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";

const PageHome = ({ videoLoaded, setVideoLoaded }) => {
  return (
    <>
      <Helmet>
        <title>
          Bent Christy Graduate Assistance Program | Ending College Debt
        </title>
        <meta
          name="description"
          content="The Bent Christy Graduate Assistance Program (BCGAP) is a nonprofit organization dedicated to helping students and families eliminate college loan debt."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "@id": "https://bcgap.org/#organization",
            name: "Bent Christy Graduate Assistance Program",
            alternateName: "BCGAP",
            url: "https://bcgap.org",
            description:
              "A nonprofit organization dedicated to helping students and families eliminate college loan debt through scholarships, repayment assistance, and community support.",
            foundingDate: "2019",
            nonprofitStatus: "Nonprofit501c3",
            potentialAction: {
              "@type": "DonateAction",
              target: {
                "@type": "EntryPoint",
                urlTemplate:
                  "https://www.paypal.com/donate/?hosted_button_id=UVY36RC5FQ374",
                actionPlatform: [
                  "http://schema.org/DesktopWebPlatform",
                  "http://schema.org/MobileWebPlatform",
                ],
              },
            },
          })}
        </script>
      </Helmet>

      <div>
        <HomeHeroBanner
          videoLoaded={videoLoaded}
          setVideoLoaded={setVideoLoaded}
        />
        <HomeSectionOne />
        <HomeSectionFour />
        <HomeSectionFive />
        <HomeSectionTwo />
        <HomeSectionThree />
      </div>
    </>
  );
};

export default PageHome;
